"use strict";

var _objectSpread = require("/vercel/path0/node_modules/@babel/runtime/helpers/objectSpread2.js").default;
var _defineProperty = require("/vercel/path0/node_modules/@babel/runtime/helpers/defineProperty.js").default;
var _G$, _GOOD;
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.G$ContractAddresses = exports.formatAmount = exports.G$Amount = exports.G$Token = exports.G$TokenContracts = exports.Envs = exports.G$Tokens = exports.G$Decimals = exports.SupportedV2Networks = exports.SupportedChains = void 0;
var core_1 = require("@usedapp/core");
var deployment_json_1 = __importDefault(require("@gooddollar/goodprotocol/releases/deployment.json"));
/* List of supported chains for this sdk. */
var SupportedChains;
(function (SupportedChains) {
  SupportedChains[SupportedChains["MAINNET"] = 1] = "MAINNET";
  SupportedChains[SupportedChains["FUSE"] = 122] = "FUSE";
  SupportedChains[SupportedChains["CELO"] = 42220] = "CELO";
})(SupportedChains = exports.SupportedChains || (exports.SupportedChains = {}));
var SupportedV2Networks;
(function (SupportedV2Networks) {
  SupportedV2Networks[SupportedV2Networks["FUSE"] = 122] = "FUSE";
  SupportedV2Networks[SupportedV2Networks["CELO"] = 42220] = "CELO";
})(SupportedV2Networks = exports.SupportedV2Networks || (exports.SupportedV2Networks = {}));
// will be used as default (fallback) values
exports.G$Decimals = {
  G$: (_G$ = {}, _defineProperty(_G$, SupportedChains.MAINNET, 2), _defineProperty(_G$, SupportedChains.FUSE, 2), _defineProperty(_G$, SupportedChains.CELO, 18), _G$),
  GOOD: (_GOOD = {}, _defineProperty(_GOOD, SupportedChains.MAINNET, 18), _defineProperty(_GOOD, SupportedChains.FUSE, 18), _defineProperty(_GOOD, SupportedChains.CELO, 18), _GOOD),
  GDX: _defineProperty({}, SupportedChains.MAINNET, 2)
};
exports.G$Tokens = Object.keys(exports.G$Decimals);
exports.Envs = {
  production: {
    dappUrl: "https://wallet.gooddollar.org",
    identityUrl: "https://goodid.gooddollar.org",
    backend: "https://goodserver.gooddollar.org"
  },
  staging: {
    dappUrl: "https://goodqa.netlify.app",
    identityUrl: "https://goodid-qa.vercel.app",
    backend: "https://goodserver-qa.herokuapp.com"
  },
  development: {
    dappUrl: "https://gooddev.netlify.app",
    identityUrl: "https://goodid-dev.vercel.app",
    backend: "https://good-server.herokuapp.com"
  }
};
exports.G$TokenContracts = {
  G$: {
    contract: "GoodDollar",
    name: "GoodDollar",
    ticker: "G$"
  },
  GOOD: {
    contract: "GReputation",
    name: "GOOD",
    ticker: "GOOD"
  },
  GDX: {
    contract: "GoodReserveCDai",
    name: "G$X",
    ticker: "GDX"
  }
};
var CURRENCIES_CASH = {};
function G$Token(tokenName, chainId, env) {
  var decimalsMap = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : exports.G$Decimals;
  var _exports$G$TokenContr = exports.G$TokenContracts[tokenName],
    contract = _exports$G$TokenContr.contract,
    name = _exports$G$TokenContr.name,
    ticker = _exports$G$TokenContr.ticker;
  var tokenEnv = env;
  var tokenChain = chainId;
  switch (tokenName) {
    case "GDX":
      tokenEnv = "production-mainnet"; // only hardcoded because of missing dev contracts (deprecated ropsten/kovan)
      tokenChain = SupportedChains.MAINNET;
      break;
    default:
      break;
  }
  var decimals = decimalsMap[tokenName][chainId];
  var address = G$ContractAddresses(contract, tokenEnv);
  var key = tokenName + "_" + chainId + "_" + decimals;
  CURRENCIES_CASH[key] = CURRENCIES_CASH[key] || new core_1.Token(name, ticker, tokenChain, address, decimals, {
    significantDigits: decimals,
    useFixedPrecision: true,
    fixedPrecisionDigits: 2
  });
  return CURRENCIES_CASH[key];
}
exports.G$Token = G$Token;
function G$Amount(tokenName, value, chainId, env) {
  var decimalsMap = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : exports.G$Decimals;
  var token = G$Token(tokenName, chainId, env, decimalsMap);
  return new core_1.CurrencyValue(token, value);
}
exports.G$Amount = G$Amount;
// display amount with X decimals
function formatAmount(value, tokenDecimals) {
  var displayDecimals = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 2;
  var currencyFormatOptions = arguments.length > 3 ? arguments[3] : undefined;
  var tokenName = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : "GoodDollar";
  var tokenSymbol = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : "G$";
  var c = new core_1.Currency(tokenName, tokenSymbol, tokenDecimals, _objectSpread({
    useFixedPrecision: true,
    fixedPrecisionDigits: displayDecimals,
    thousandSeparator: ""
  }, currencyFormatOptions));
  return new core_1.CurrencyValue(c, value).format();
}
exports.formatAmount = formatAmount;
function G$ContractAddresses(name, env) {
  if (!deployment_json_1.default[env]) {
    console.warn("tokens: Unsupported chain ID ".concat(env), env);
    env = env.includes("mainnet") ? env + "-mainnet" : env;
  }
  if (!deployment_json_1.default[env][name]) {
    throw new Error("Inappropriate contract name ".concat(name, " in ").concat(env));
  }
  return deployment_json_1.default[env][name];
}
exports.G$ContractAddresses = G$ContractAddresses;